import { keepPreviousData } from '@tanstack/react-query';

import { Environment } from '@playq/octopus-common';
import { GenericFailure, ServicesCompanyID } from '@playq/services-shared';
import { AliasId, PrivateIdentity } from '@playq/services-fingerprint';

import { IUseQueryOptionsExtended, useEitherQuery } from '/api/service-hooks';
import { services2 } from '/api/services2';

import { playerLookupKeys } from './constants';

export const useProfileRetriveByAlias = (
  { companyID, alias, env }: { companyID?: ServicesCompanyID; alias: AliasId; env: Environment },
  options?: IUseQueryOptionsExtended<PrivateIdentity | undefined, GenericFailure | Error>
) => {
  return useEitherQuery(
    playerLookupKeys.loginByAlias(alias, env, companyID),
    () => {
      if (companyID) {
        return services2.fingerprintLookupService.retrieveProfileByAlias(companyID, alias, env);
      }
    },
    {
      placeholderData: keepPreviousData,
      ...options,
    }
  );
};
